angular.module('app')
    .controller('gestioneMoratoriaCtrl', function (
        $scope,
        $arcService,
        $modalService,
        $location,
        $configService
    ) {

        
       $scope.initialize = function(){
           $scope.otherLabel=[];
           $scope.navigator={
               enableButtonNextStep: false,
               loading:{
                   backStep: false,
                   suspend: false,
                   nextStep: false
               }
           }

           $scope.ndg= $configService.getUser().ndg;

           $scope.label = "LBL_INFO_MORATORIA_1"
           $scope.otherLabel[0]="LBL_INFO_MORATORIA_2"
           $scope.otherLabel[1]="LBL_INFO_MORATORIA_3"
           $scope.otherLabel[2]="LBL_INFO_MORATORIA_4"
       }

       

       $scope.next = function(value){
           $scope.navigator.loading.nextStep= true;
           if(!value){
               $modalService.openModal("confirmSelected");
               $scope.navigator.loading.nextStep= false;
           }else{
               $modalService.closeModal("confirmSelected");
               $arcService.submitMoratoria($scope.popolateListOfContract(), $scope.ndg )
                .then(function(response){
                    if(response.success){
                        $location.path("/");
                    }
                    $scope.navigator.loading.nextStep= false;
                })
                .catch(function(error){
                    console.log(error);
                    $scope.navigator.loading.nextStep= false;
                })

           }     
       }

       $scope.closeModal= function(){
           $modalService.closeModal("confirmSelected");
       }

       $scope.enableNextStep = function(value){

           $scope.navigator.enableButtonNextStep= value;
       }

       $scope.popolateListOfContract = function(){
           return $scope.listaContrattiMoratoria && $scope.listaContrattiMoratoria.filter(function(e){
                        return e.selected ==true;
                    }).map(function(el){
                        return {numeroContratto: el.numeroContratto,
                                tipoMoratoria: el.tipoMoratoria,
                                numeroModulo: el.numeroModulo
                        }
                    })

       }

    })